import React, { useState, useEffect } from 'react';
import './EditorStyles.css';

const ContactEditor = () => {
  const [content, setContent] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    loadContent();
  }, []);

  const loadContent = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://server.acpca.net/api'}/content/all`);
      const data = await response.json();
      if (data.success) {
        setContent(data.data.contact || {});
      }
    } catch (error) {
      console.error('Error loading content:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    setSaving(true);
    setMessage('');

    try {
      const token = localStorage.getItem('dashboard_token');
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://server.acpca.net/api'}/content/contact`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(content)
      });

      const data = await response.json();
      if (data.success) {
        setMessage('تم حفظ قسم التواصل بنجاح!');
        setTimeout(() => setMessage(''), 3000);
      } else {
        setMessage(data.message || 'خطأ في حفظ المحتوى');
      }
    } catch (error) {
      setMessage('خطأ في الاتصال');
      console.error('Save error:', error);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="editor-loading">جاري التحميل...</div>;
  }

  return (
    <div className="editor-container">
      <div className="editor-header">
        <h2>محرر قسم التواصل</h2>
        {message && (
          <div className={`editor-message ${message.includes('نجح') || message.includes('success') ? 'success' : 'error'}`}>
            {message}
          </div>
        )}
      </div>

      <div className="editor-grid">
        <div className="editor-column">
          <h3>المحتوى العربي</h3>
          <div className="editor-form-group">
            <label>العلامة</label>
            <input
              type="text"
              value={content.tag_ar || ''}
              onChange={(e) => setContent({...content, tag_ar: e.target.value})}
            />
          </div>
          <div className="editor-form-group">
            <label>العنوان</label>
            <textarea
              rows="2"
              value={content.title_ar || ''}
              onChange={(e) => setContent({...content, title_ar: e.target.value})}
            />
          </div>
          <div className="editor-form-group">
            <label>الوصف</label>
            <textarea
              rows="4"
              value={content.description_ar || ''}
              onChange={(e) => setContent({...content, description_ar: e.target.value})}
            />
          </div>
          <div className="editor-form-group">
            <label>عنوان النموذج</label>
            <input
              type="text"
              value={content.form_title_ar || ''}
              onChange={(e) => setContent({...content, form_title_ar: e.target.value})}
            />
          </div>
          <div className="editor-form-group">
            <label>وصف النموذج</label>
            <textarea
              rows="3"
              value={content.form_description_ar || ''}
              onChange={(e) => setContent({...content, form_description_ar: e.target.value})}
            />
          </div>
        </div>

        <div className="editor-column">
          <h3>المحتوى الإنجليزي</h3>
          <div className="editor-form-group">
            <label>Tag (English)</label>
            <input
              type="text"
              value={content.tag_en || ''}
              onChange={(e) => setContent({...content, tag_en: e.target.value})}
            />
          </div>
          <div className="editor-form-group">
            <label>Title (English)</label>
            <textarea
              rows="2"
              value={content.title_en || ''}
              onChange={(e) => setContent({...content, title_en: e.target.value})}
            />
          </div>
          <div className="editor-form-group">
            <label>Description (English)</label>
            <textarea
              rows="4"
              value={content.description_en || ''}
              onChange={(e) => setContent({...content, description_en: e.target.value})}
            />
          </div>
          <div className="editor-form-group">
            <label>Form Title (English)</label>
            <input
              type="text"
              value={content.form_title_en || ''}
              onChange={(e) => setContent({...content, form_title_en: e.target.value})}
            />
          </div>
          <div className="editor-form-group">
            <label>Form Description (English)</label>
            <textarea
              rows="3"
              value={content.form_description_en || ''}
              onChange={(e) => setContent({...content, form_description_en: e.target.value})}
            />
          </div>
        </div>
      </div>

      <h3 style={{ marginTop: '30px', marginBottom: '20px', color: '#815327' }}>معلومات الموقع</h3>
      <div className="editor-grid">
        <div className="editor-column">
          <div className="editor-form-group">
            <label>المدينة (عربي)</label>
            <input
              type="text"
              value={content.location_city_ar || ''}
              onChange={(e) => setContent({...content, location_city_ar: e.target.value})}
            />
          </div>
          <div className="editor-form-group">
            <label>العنوان (عربي)</label>
            <input
              type="text"
              value={content.location_address_ar || ''}
              onChange={(e) => setContent({...content, location_address_ar: e.target.value})}
            />
          </div>
        </div>
        <div className="editor-column">
          <div className="editor-form-group">
            <label>City (English)</label>
            <input
              type="text"
              value={content.location_city_en || ''}
              onChange={(e) => setContent({...content, location_city_en: e.target.value})}
            />
          </div>
          <div className="editor-form-group">
            <label>Address (English)</label>
            <input
              type="text"
              value={content.location_address_en || ''}
              onChange={(e) => setContent({...content, location_address_en: e.target.value})}
            />
          </div>
        </div>
      </div>

      <div className="editor-form-group">
        <label>البريد الإلكتروني</label>
        <input
          type="email"
          value={content.location_email || ''}
          onChange={(e) => setContent({...content, location_email: e.target.value})}
        />
      </div>

      <div className="editor-form-group">
        <label>رقم الهاتف</label>
        <input
          type="text"
          value={content.location_phone || ''}
          onChange={(e) => setContent({...content, location_phone: e.target.value})}
        />
      </div>

      <div className="editor-actions">
        <button className="editor-btn-save" onClick={handleSave} disabled={saving}>
          {saving ? 'جاري الحفظ...' : 'حفظ التغييرات'}
        </button>
      </div>
    </div>
  );
};

export default ContactEditor;

